import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';

import { CustomerTypeDto } from '@/api/generated';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const CustomersHeaderAdd: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.customers.header');
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const { push } = useAppNavigation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCreateCustomer =
    (
      route:
        | RouteEnum.CUSTOMERS_CREATE_BUSINESS
        | RouteEnum.CUSTOMERS_CREATE_FOREIGN
        | RouteEnum.CUSTOMERS_CREATE_INDIVIDUAL,
    ) =>
    () => {
      handleCloseMenu();
      push(route);
    };

  return (
    <>
      <Button onClick={handleClick} variant="outlined">
        {t('button.add')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        onClose={handleCloseMenu}
        open={open}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
      >
        <MenuItem onClick={handleCreateCustomer(RouteEnum.CUSTOMERS_CREATE_INDIVIDUAL)}>
          {t(`menu.${CustomerTypeDto.Individual}`)}
        </MenuItem>
        <MenuItem onClick={handleCreateCustomer(RouteEnum.CUSTOMERS_CREATE_BUSINESS)}>
          {t(`menu.${CustomerTypeDto.Business}`)}
        </MenuItem>
        <MenuItem onClick={handleCreateCustomer(RouteEnum.CUSTOMERS_CREATE_FOREIGN)}>
          {t(`menu.${CustomerTypeDto.ForeignBusiness}`)}
        </MenuItem>
      </Menu>
    </>
  );
};
